import * as Types from '../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ListProcessCodesQueryVariables = Types.Exact<{
  select: Types.Scalars['String']['input'];
  username: Types.Scalars['String']['input'];
}>;


export type ListProcessCodesQuery = { __typename?: 'Query', listProcessCodes?: Array<{ __typename?: 'selectProcessCode', id: string, processCode?: string | null, processCodeName?: string | null, phraseId?: string | null }> | null };

export type GetDocumentStatusQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetDocumentStatusQuery = { __typename?: 'Query', getDocumentStatus?: Array<{ __typename?: 'selectStatus', id: string, documentStatus: string, phraseId: string, insertTime: string, isFinalStatus: boolean, updateTime: string }> | null };

export type GetDocumentFormatQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetDocumentFormatQuery = { __typename?: 'Query', getDocumentFormat?: Array<{ __typename?: 'selectFormat', id: string, documentFormat?: string | null, insertTime?: string | null, insertUser?: string | null, updateUser?: string | null }> | null };

export type GetAllDocumentTypesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetAllDocumentTypesQuery = { __typename?: 'Query', getAllDocumentTypes?: Array<{ __typename?: 'selectDocType', id: string, documentDescription?: string | null, documentType?: string | null, insertTime?: string | null, insertUser?: string | null, updateTime?: string | null, updateUser?: string | null, phraseId?: string | null, serviceProviderId?: number | null, serviceProviderName?: string | null }> | null };

export type GetFilteredDocumentTypesQueryVariables = Types.Exact<{
  entitlement: Types.Scalars['String']['input'];
}>;


export type GetFilteredDocumentTypesQuery = { __typename?: 'Query', getFilteredDocumentTypes?: Array<{ __typename?: 'selectDocType', id: string, documentDescription?: string | null, documentType?: string | null, insertTime?: string | null, insertUser?: string | null, updateTime?: string | null, updateUser?: string | null, phraseId?: string | null, serviceProviderId?: number | null, serviceProviderName?: string | null }> | null };

export type GetProviderDocumentTypeQueryVariables = Types.Exact<{
  serviceProviderId: Types.Scalars['Float']['input'];
}>;


export type GetProviderDocumentTypeQuery = { __typename?: 'Query', getProviderDocumentType?: Array<{ __typename?: 'selectDocType', id: string, documentDescription?: string | null, documentType?: string | null, insertTime?: string | null, insertUser?: string | null, updateTime?: string | null, updateUser?: string | null, phraseId?: string | null, serviceProviderId?: number | null, serviceProviderName?: string | null }> | null };

export type GetDocumentListQueryVariables = Types.Exact<{
  documentInput: Types.DocumentInput;
}>;


export type GetDocumentListQuery = { __typename?: 'Query', getPartnerDocuments?: Array<{ __typename?: 'Document', amount?: number | null, azContainerName?: string | null, azDownloadFileName?: string | null, azItemPathName?: string | null, azStorageType?: string | null, blobId?: string | null, companyCode?: string | null, companyName?: string | null, currency?: string | null, dateReceived?: string | null, documentId?: number | null, downloadLink?: string | null, downloaded?: number | null, insertTs?: string | null, partnerName?: string | null, partnerno?: string | null, processCode?: string | null, quantity?: number | null, reference?: string | null, systemCode?: string | null, updatetime?: string | null, area?: string | null }> | null };

export type GetDocCountQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetDocCountQuery = { __typename?: 'Query', getDocumentsCount: { __typename?: 'DocumentCount', count: number } };

export type DownloadDocumentQueryVariables = Types.Exact<{
  documentDownloadInput: Types.DocumentDownloadInput;
}>;


export type DownloadDocumentQuery = { __typename?: 'Query', downloadDocument: { __typename?: 'DocumentDownloadResponse', zipFileData?: Array<string> | null, encodedZipFileData?: string | null, errorMessage?: string | null, failureDocuments?: Array<{ __typename?: 'DocumentDownload', documentId?: number | null, documentName?: string | null, documentLink?: string | null, documentPath?: string | null }> | null, successDocuments?: Array<{ __typename?: 'DocumentDownload', documentId?: number | null, documentName?: string | null, documentLink?: string | null, documentPath?: string | null }> | null } };

export type DownloadDocumentEcapTLogInfoQueryVariables = Types.Exact<{
  documentDownloadInputs: Array<Types.DocumentDownloadInputs> | Types.DocumentDownloadInputs;
}>;


export type DownloadDocumentEcapTLogInfoQuery = { __typename?: 'Query', downloadDocumentEcapTLogInfo: { __typename?: 'DocumentDownloadResponses', zipFileData?: Array<string> | null, encodedZipFileData?: string | null, errorMessage?: string | null, failureDocuments?: Array<{ __typename?: 'DocumentDownloads', id?: number | null, blobId?: number | null, messageId?: string | null, errorMessage?: string | null }> | null, successDocuments?: Array<{ __typename?: 'DocumentDownloads', id?: number | null, messageId?: string | null, blobId?: number | null }> | null } };

export type DownloadDocumentEcapQueryVariables = Types.Exact<{
  documentDownloadInputs: Array<Types.DocumentDownloadInputs> | Types.DocumentDownloadInputs;
}>;


export type DownloadDocumentEcapQuery = { __typename?: 'Query', downloadDocumentEcap: { __typename?: 'DocumentDownloadResponses', zipFileData?: Array<string> | null, encodedZipFileData?: string | null, errorMessage?: string | null, failureDocuments?: Array<{ __typename?: 'DocumentDownloads', id?: number | null, blobId?: number | null, messageId?: string | null, errorMessage?: string | null }> | null, successDocuments?: Array<{ __typename?: 'DocumentDownloads', id?: number | null, messageId?: string | null, blobId?: number | null }> | null } };

export type DownloadMultiDocumentQueryVariables = Types.Exact<{
  documentDownloadInputs: Array<Types.DocumentDownloadInput> | Types.DocumentDownloadInput;
}>;


export type DownloadMultiDocumentQuery = { __typename?: 'Query', downloadMultipleDocument: { __typename?: 'DocumentDownloadResponse', zipFileData?: Array<string> | null, encodedZipFileData?: string | null, errorMessage?: string | null, failureDocuments?: Array<{ __typename?: 'DocumentDownload', documentId?: number | null, documentName?: string | null, documentLink?: string | null, documentPath?: string | null, errorMessage?: string | null }> | null, successDocuments?: Array<{ __typename?: 'DocumentDownload', documentId?: number | null, documentName?: string | null, documentLink?: string | null, documentPath?: string | null }> | null } };

export type GetPartnerDocsListQueryVariables = Types.Exact<{
  docListInput: Types.DocListInput;
}>;


export type GetPartnerDocsListQuery = { __typename?: 'Query', getPartnerDocsList?: Array<{ __typename?: 'DocList', id?: number | null, blobId?: number | null, messageId?: string | null, duplicate?: number | null, bmwCompany?: string | null, country?: string | null, currency?: string | null, documentDate?: string | null, documentNumber?: string | null, documentType?: string | null, phraseId?: string | null, downloaded?: string | null, format?: string | null, grossAmount?: number | null, partnerName?: string | null, partnerNumber?: string | null, processCode?: string | null, receptionDate?: string | null, sdiNumber?: string | null, status?: string | null, taxAmount?: number | null, vinNumber?: string | null, statusPhraseId?: string | null, fileName?: string | null, attachment?: string | null, shipPartnerNo?: string | null, externalDocumentNumber?: string | null }> | null };

export type GetFsmPartnerDocsListQueryVariables = Types.Exact<{
  docListInput: Types.DocListInput;
}>;


export type GetFsmPartnerDocsListQuery = { __typename?: 'Query', getFsmPartnerDocsList?: Array<{ __typename?: 'DocList', id?: number | null, blobId?: number | null, fileName?: string | null, messageId?: string | null, duplicate?: number | null, bmwCompany?: string | null, country?: string | null, currency?: string | null, documentDate?: string | null, documentNumber?: string | null, documentType?: string | null, phraseId?: string | null, downloaded?: string | null, format?: string | null, grossAmount?: number | null, partnerName?: string | null, partnerNumber?: string | null, processCode?: string | null, receptionDate?: string | null, sdiNumber?: string | null, status?: string | null, taxAmount?: number | null, vinNumber?: string | null, statusPhraseId?: string | null, errorMessage?: string | null, attachment?: string | null, shipPartnerNo?: string | null, externalDocumentNumber?: string | null }> | null };

export type GetMissingInvoicesDocsListQueryVariables = Types.Exact<{
  docListInput: Types.DocListInput;
}>;


export type GetMissingInvoicesDocsListQuery = { __typename?: 'Query', getMissingInvoicesDocsList: Array<{ __typename?: 'MissingInvoice', ecDocumentId?: number | null, messageId?: string | null, partnerNo?: string | null, companyPartnerId?: string | null, correctCompanyPartnerId?: string | null, documentNumber?: string | null, street1?: string | null, street2?: string | null, city?: string | null, countryCode?: string | null, postalCode?: string | null, region?: string | null, regionCode?: string | null, companyVatCountryCode?: string | null, companyVatCode?: string | null, companyVatCodeFromCompanyVatCode?: string | null, companyVatCountryCodeFromCompanyVatCode?: string | null, insertUser?: string | null, insertTime?: string | null, companyNameFromPartnerCompanySystem?: string | null, companyCode?: string | null, companyCodeFromPartnerCompanySystem?: string | null, category?: string | null, partnerAddressTypeFromPartnerAddress?: string | null, partnerCityFromPartnerAddress?: string | null, partnerCountryCodeFromPartnerAddress?: string | null, partnerName?: string | null, partnerNameFromPartnerCompanySystem?: string | null, partnerNoFromPartnerCompanySystem?: string | null, partnerPostalCodeFromPartnerAddress?: string | null, partnerRegionFromPartnerAddress?: string | null, partnerRegionCodeFromPartnerAddress?: string | null, partnerStreet1FromPartnerAddress?: string | null, partnerStreet2FromPartnerAddress?: string | null, partnerVatCode?: string | null, partnerVatCodeFromPartnerVatCode?: string | null, partnerVatCountryCodeFromPartnerVatCode?: string | null, partnerVatCountryCode?: string | null, processingStatusFlag?: string | null, updateTime?: string | null, partnerNoIssue?: string | null, partnerNameIssue?: string | null, companyCodeIssue?: string | null, partnerAddressIssue?: string | null, countryCodeAddressIssue?: string | null, partnerVatCodeIssue?: string | null, partnerVatCountryCodeIssue?: string | null, companyPartnerIdIssue?: string | null, companyVatCodeIssue?: string | null, attachmentPending?: string | null, logInfoId?: number | null, fileName?: string | null, blobId?: number | null, discrepancies?: boolean | null }> };

export type GetMissingInvoicesDocsListGroupedQueryVariables = Types.Exact<{
  docListInput: Types.DocListInput;
}>;


export type GetMissingInvoicesDocsListGroupedQuery = { __typename?: 'Query', getMissingInvoicesDocsListGrouped: Array<{ __typename?: 'MissingInvoiceGrouped', rowNo?: number | null, processingStatusFlag?: string | null, updateTime?: string | null }> };


export const ListProcessCodesDocument = gql`
    query listProcessCodes($select: String!, $username: String!) {
  listProcessCodes(select: $select, username: $username) {
    id
    processCode
    processCodeName
    phraseId
  }
}
    `;

/**
 * __useListProcessCodesQuery__
 *
 * To run a query within a React component, call `useListProcessCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProcessCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProcessCodesQuery({
 *   variables: {
 *      select: // value for 'select'
 *      username: // value for 'username'
 *   },
 * });
 */
export function useListProcessCodesQuery(baseOptions: Apollo.QueryHookOptions<ListProcessCodesQuery, ListProcessCodesQueryVariables> & ({ variables: ListProcessCodesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListProcessCodesQuery, ListProcessCodesQueryVariables>(ListProcessCodesDocument, options);
      }
export function useListProcessCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListProcessCodesQuery, ListProcessCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListProcessCodesQuery, ListProcessCodesQueryVariables>(ListProcessCodesDocument, options);
        }
// @ts-ignore
export function useListProcessCodesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListProcessCodesQuery, ListProcessCodesQueryVariables>): Apollo.UseSuspenseQueryResult<ListProcessCodesQuery, ListProcessCodesQueryVariables>;
export function useListProcessCodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListProcessCodesQuery, ListProcessCodesQueryVariables>): Apollo.UseSuspenseQueryResult<ListProcessCodesQuery | undefined, ListProcessCodesQueryVariables>;
export function useListProcessCodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListProcessCodesQuery, ListProcessCodesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListProcessCodesQuery, ListProcessCodesQueryVariables>(ListProcessCodesDocument, options);
        }
export type ListProcessCodesQueryHookResult = ReturnType<typeof useListProcessCodesQuery>;
export type ListProcessCodesLazyQueryHookResult = ReturnType<typeof useListProcessCodesLazyQuery>;
export type ListProcessCodesSuspenseQueryHookResult = ReturnType<typeof useListProcessCodesSuspenseQuery>;
export type ListProcessCodesQueryResult = Apollo.QueryResult<ListProcessCodesQuery, ListProcessCodesQueryVariables>;
export const GetDocumentStatusDocument = gql`
    query getDocumentStatus {
  getDocumentStatus {
    id
    documentStatus
    phraseId
    insertTime
    isFinalStatus
    updateTime
  }
}
    `;

/**
 * __useGetDocumentStatusQuery__
 *
 * To run a query within a React component, call `useGetDocumentStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDocumentStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetDocumentStatusQuery, GetDocumentStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentStatusQuery, GetDocumentStatusQueryVariables>(GetDocumentStatusDocument, options);
      }
export function useGetDocumentStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentStatusQuery, GetDocumentStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentStatusQuery, GetDocumentStatusQueryVariables>(GetDocumentStatusDocument, options);
        }
// @ts-ignore
export function useGetDocumentStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDocumentStatusQuery, GetDocumentStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetDocumentStatusQuery, GetDocumentStatusQueryVariables>;
export function useGetDocumentStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDocumentStatusQuery, GetDocumentStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetDocumentStatusQuery | undefined, GetDocumentStatusQueryVariables>;
export function useGetDocumentStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDocumentStatusQuery, GetDocumentStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDocumentStatusQuery, GetDocumentStatusQueryVariables>(GetDocumentStatusDocument, options);
        }
export type GetDocumentStatusQueryHookResult = ReturnType<typeof useGetDocumentStatusQuery>;
export type GetDocumentStatusLazyQueryHookResult = ReturnType<typeof useGetDocumentStatusLazyQuery>;
export type GetDocumentStatusSuspenseQueryHookResult = ReturnType<typeof useGetDocumentStatusSuspenseQuery>;
export type GetDocumentStatusQueryResult = Apollo.QueryResult<GetDocumentStatusQuery, GetDocumentStatusQueryVariables>;
export const GetDocumentFormatDocument = gql`
    query getDocumentFormat {
  getDocumentFormat {
    id
    documentFormat
    insertTime
    insertUser
    updateUser
  }
}
    `;

/**
 * __useGetDocumentFormatQuery__
 *
 * To run a query within a React component, call `useGetDocumentFormatQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentFormatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentFormatQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDocumentFormatQuery(baseOptions?: Apollo.QueryHookOptions<GetDocumentFormatQuery, GetDocumentFormatQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentFormatQuery, GetDocumentFormatQueryVariables>(GetDocumentFormatDocument, options);
      }
export function useGetDocumentFormatLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentFormatQuery, GetDocumentFormatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentFormatQuery, GetDocumentFormatQueryVariables>(GetDocumentFormatDocument, options);
        }
// @ts-ignore
export function useGetDocumentFormatSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDocumentFormatQuery, GetDocumentFormatQueryVariables>): Apollo.UseSuspenseQueryResult<GetDocumentFormatQuery, GetDocumentFormatQueryVariables>;
export function useGetDocumentFormatSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDocumentFormatQuery, GetDocumentFormatQueryVariables>): Apollo.UseSuspenseQueryResult<GetDocumentFormatQuery | undefined, GetDocumentFormatQueryVariables>;
export function useGetDocumentFormatSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDocumentFormatQuery, GetDocumentFormatQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDocumentFormatQuery, GetDocumentFormatQueryVariables>(GetDocumentFormatDocument, options);
        }
export type GetDocumentFormatQueryHookResult = ReturnType<typeof useGetDocumentFormatQuery>;
export type GetDocumentFormatLazyQueryHookResult = ReturnType<typeof useGetDocumentFormatLazyQuery>;
export type GetDocumentFormatSuspenseQueryHookResult = ReturnType<typeof useGetDocumentFormatSuspenseQuery>;
export type GetDocumentFormatQueryResult = Apollo.QueryResult<GetDocumentFormatQuery, GetDocumentFormatQueryVariables>;
export const GetAllDocumentTypesDocument = gql`
    query getAllDocumentTypes {
  getAllDocumentTypes {
    id
    documentDescription
    documentType
    insertTime
    insertUser
    updateTime
    updateUser
    phraseId
    serviceProviderId
    serviceProviderName
  }
}
    `;

/**
 * __useGetAllDocumentTypesQuery__
 *
 * To run a query within a React component, call `useGetAllDocumentTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllDocumentTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllDocumentTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllDocumentTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllDocumentTypesQuery, GetAllDocumentTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllDocumentTypesQuery, GetAllDocumentTypesQueryVariables>(GetAllDocumentTypesDocument, options);
      }
export function useGetAllDocumentTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllDocumentTypesQuery, GetAllDocumentTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllDocumentTypesQuery, GetAllDocumentTypesQueryVariables>(GetAllDocumentTypesDocument, options);
        }
// @ts-ignore
export function useGetAllDocumentTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllDocumentTypesQuery, GetAllDocumentTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllDocumentTypesQuery, GetAllDocumentTypesQueryVariables>;
export function useGetAllDocumentTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllDocumentTypesQuery, GetAllDocumentTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllDocumentTypesQuery | undefined, GetAllDocumentTypesQueryVariables>;
export function useGetAllDocumentTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllDocumentTypesQuery, GetAllDocumentTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllDocumentTypesQuery, GetAllDocumentTypesQueryVariables>(GetAllDocumentTypesDocument, options);
        }
export type GetAllDocumentTypesQueryHookResult = ReturnType<typeof useGetAllDocumentTypesQuery>;
export type GetAllDocumentTypesLazyQueryHookResult = ReturnType<typeof useGetAllDocumentTypesLazyQuery>;
export type GetAllDocumentTypesSuspenseQueryHookResult = ReturnType<typeof useGetAllDocumentTypesSuspenseQuery>;
export type GetAllDocumentTypesQueryResult = Apollo.QueryResult<GetAllDocumentTypesQuery, GetAllDocumentTypesQueryVariables>;
export const GetFilteredDocumentTypesDocument = gql`
    query getFilteredDocumentTypes($entitlement: String!) {
  getFilteredDocumentTypes(entitlement: $entitlement) {
    id
    documentDescription
    documentType
    insertTime
    insertUser
    updateTime
    updateUser
    phraseId
    serviceProviderId
    serviceProviderName
  }
}
    `;

/**
 * __useGetFilteredDocumentTypesQuery__
 *
 * To run a query within a React component, call `useGetFilteredDocumentTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilteredDocumentTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilteredDocumentTypesQuery({
 *   variables: {
 *      entitlement: // value for 'entitlement'
 *   },
 * });
 */
export function useGetFilteredDocumentTypesQuery(baseOptions: Apollo.QueryHookOptions<GetFilteredDocumentTypesQuery, GetFilteredDocumentTypesQueryVariables> & ({ variables: GetFilteredDocumentTypesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilteredDocumentTypesQuery, GetFilteredDocumentTypesQueryVariables>(GetFilteredDocumentTypesDocument, options);
      }
export function useGetFilteredDocumentTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilteredDocumentTypesQuery, GetFilteredDocumentTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilteredDocumentTypesQuery, GetFilteredDocumentTypesQueryVariables>(GetFilteredDocumentTypesDocument, options);
        }
// @ts-ignore
export function useGetFilteredDocumentTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFilteredDocumentTypesQuery, GetFilteredDocumentTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GetFilteredDocumentTypesQuery, GetFilteredDocumentTypesQueryVariables>;
export function useGetFilteredDocumentTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFilteredDocumentTypesQuery, GetFilteredDocumentTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GetFilteredDocumentTypesQuery | undefined, GetFilteredDocumentTypesQueryVariables>;
export function useGetFilteredDocumentTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFilteredDocumentTypesQuery, GetFilteredDocumentTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFilteredDocumentTypesQuery, GetFilteredDocumentTypesQueryVariables>(GetFilteredDocumentTypesDocument, options);
        }
export type GetFilteredDocumentTypesQueryHookResult = ReturnType<typeof useGetFilteredDocumentTypesQuery>;
export type GetFilteredDocumentTypesLazyQueryHookResult = ReturnType<typeof useGetFilteredDocumentTypesLazyQuery>;
export type GetFilteredDocumentTypesSuspenseQueryHookResult = ReturnType<typeof useGetFilteredDocumentTypesSuspenseQuery>;
export type GetFilteredDocumentTypesQueryResult = Apollo.QueryResult<GetFilteredDocumentTypesQuery, GetFilteredDocumentTypesQueryVariables>;
export const GetProviderDocumentTypeDocument = gql`
    query getProviderDocumentType($serviceProviderId: Float!) {
  getProviderDocumentType(serviceProviderId: $serviceProviderId) {
    id
    documentDescription
    documentType
    insertTime
    insertUser
    updateTime
    updateUser
    phraseId
    serviceProviderId
    serviceProviderName
  }
}
    `;

/**
 * __useGetProviderDocumentTypeQuery__
 *
 * To run a query within a React component, call `useGetProviderDocumentTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderDocumentTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderDocumentTypeQuery({
 *   variables: {
 *      serviceProviderId: // value for 'serviceProviderId'
 *   },
 * });
 */
export function useGetProviderDocumentTypeQuery(baseOptions: Apollo.QueryHookOptions<GetProviderDocumentTypeQuery, GetProviderDocumentTypeQueryVariables> & ({ variables: GetProviderDocumentTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProviderDocumentTypeQuery, GetProviderDocumentTypeQueryVariables>(GetProviderDocumentTypeDocument, options);
      }
export function useGetProviderDocumentTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProviderDocumentTypeQuery, GetProviderDocumentTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProviderDocumentTypeQuery, GetProviderDocumentTypeQueryVariables>(GetProviderDocumentTypeDocument, options);
        }
// @ts-ignore
export function useGetProviderDocumentTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProviderDocumentTypeQuery, GetProviderDocumentTypeQueryVariables>): Apollo.UseSuspenseQueryResult<GetProviderDocumentTypeQuery, GetProviderDocumentTypeQueryVariables>;
export function useGetProviderDocumentTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProviderDocumentTypeQuery, GetProviderDocumentTypeQueryVariables>): Apollo.UseSuspenseQueryResult<GetProviderDocumentTypeQuery | undefined, GetProviderDocumentTypeQueryVariables>;
export function useGetProviderDocumentTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProviderDocumentTypeQuery, GetProviderDocumentTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProviderDocumentTypeQuery, GetProviderDocumentTypeQueryVariables>(GetProviderDocumentTypeDocument, options);
        }
export type GetProviderDocumentTypeQueryHookResult = ReturnType<typeof useGetProviderDocumentTypeQuery>;
export type GetProviderDocumentTypeLazyQueryHookResult = ReturnType<typeof useGetProviderDocumentTypeLazyQuery>;
export type GetProviderDocumentTypeSuspenseQueryHookResult = ReturnType<typeof useGetProviderDocumentTypeSuspenseQuery>;
export type GetProviderDocumentTypeQueryResult = Apollo.QueryResult<GetProviderDocumentTypeQuery, GetProviderDocumentTypeQueryVariables>;
export const GetDocumentListDocument = gql`
    query getDocumentList($documentInput: DocumentInput!) {
  getPartnerDocuments(documentInput: $documentInput) {
    amount
    azContainerName
    azDownloadFileName
    azItemPathName
    azStorageType
    blobId
    companyCode
    companyName
    currency
    dateReceived
    documentId
    downloadLink
    downloaded
    insertTs
    blobId
    partnerName
    partnerno
    processCode
    quantity
    reference
    systemCode
    updatetime
    area
  }
}
    `;

/**
 * __useGetDocumentListQuery__
 *
 * To run a query within a React component, call `useGetDocumentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentListQuery({
 *   variables: {
 *      documentInput: // value for 'documentInput'
 *   },
 * });
 */
export function useGetDocumentListQuery(baseOptions: Apollo.QueryHookOptions<GetDocumentListQuery, GetDocumentListQueryVariables> & ({ variables: GetDocumentListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentListQuery, GetDocumentListQueryVariables>(GetDocumentListDocument, options);
      }
export function useGetDocumentListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentListQuery, GetDocumentListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentListQuery, GetDocumentListQueryVariables>(GetDocumentListDocument, options);
        }
// @ts-ignore
export function useGetDocumentListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDocumentListQuery, GetDocumentListQueryVariables>): Apollo.UseSuspenseQueryResult<GetDocumentListQuery, GetDocumentListQueryVariables>;
export function useGetDocumentListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDocumentListQuery, GetDocumentListQueryVariables>): Apollo.UseSuspenseQueryResult<GetDocumentListQuery | undefined, GetDocumentListQueryVariables>;
export function useGetDocumentListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDocumentListQuery, GetDocumentListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDocumentListQuery, GetDocumentListQueryVariables>(GetDocumentListDocument, options);
        }
export type GetDocumentListQueryHookResult = ReturnType<typeof useGetDocumentListQuery>;
export type GetDocumentListLazyQueryHookResult = ReturnType<typeof useGetDocumentListLazyQuery>;
export type GetDocumentListSuspenseQueryHookResult = ReturnType<typeof useGetDocumentListSuspenseQuery>;
export type GetDocumentListQueryResult = Apollo.QueryResult<GetDocumentListQuery, GetDocumentListQueryVariables>;
export const GetDocCountDocument = gql`
    query getDocCount {
  getDocumentsCount {
    count
  }
}
    `;

/**
 * __useGetDocCountQuery__
 *
 * To run a query within a React component, call `useGetDocCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDocCountQuery(baseOptions?: Apollo.QueryHookOptions<GetDocCountQuery, GetDocCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocCountQuery, GetDocCountQueryVariables>(GetDocCountDocument, options);
      }
export function useGetDocCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocCountQuery, GetDocCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocCountQuery, GetDocCountQueryVariables>(GetDocCountDocument, options);
        }
// @ts-ignore
export function useGetDocCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDocCountQuery, GetDocCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetDocCountQuery, GetDocCountQueryVariables>;
export function useGetDocCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDocCountQuery, GetDocCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetDocCountQuery | undefined, GetDocCountQueryVariables>;
export function useGetDocCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDocCountQuery, GetDocCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDocCountQuery, GetDocCountQueryVariables>(GetDocCountDocument, options);
        }
export type GetDocCountQueryHookResult = ReturnType<typeof useGetDocCountQuery>;
export type GetDocCountLazyQueryHookResult = ReturnType<typeof useGetDocCountLazyQuery>;
export type GetDocCountSuspenseQueryHookResult = ReturnType<typeof useGetDocCountSuspenseQuery>;
export type GetDocCountQueryResult = Apollo.QueryResult<GetDocCountQuery, GetDocCountQueryVariables>;
export const DownloadDocumentDocument = gql`
    query downloadDocument($documentDownloadInput: DocumentDownloadInput!) {
  downloadDocument(documentDownloadInput: $documentDownloadInput) {
    failureDocuments {
      documentId
      documentName
      documentLink
      documentPath
    }
    successDocuments {
      documentId
      documentName
      documentLink
      documentPath
    }
    zipFileData
    encodedZipFileData
    errorMessage
  }
}
    `;

/**
 * __useDownloadDocumentQuery__
 *
 * To run a query within a React component, call `useDownloadDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadDocumentQuery({
 *   variables: {
 *      documentDownloadInput: // value for 'documentDownloadInput'
 *   },
 * });
 */
export function useDownloadDocumentQuery(baseOptions: Apollo.QueryHookOptions<DownloadDocumentQuery, DownloadDocumentQueryVariables> & ({ variables: DownloadDocumentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadDocumentQuery, DownloadDocumentQueryVariables>(DownloadDocumentDocument, options);
      }
export function useDownloadDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadDocumentQuery, DownloadDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadDocumentQuery, DownloadDocumentQueryVariables>(DownloadDocumentDocument, options);
        }
// @ts-ignore
export function useDownloadDocumentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DownloadDocumentQuery, DownloadDocumentQueryVariables>): Apollo.UseSuspenseQueryResult<DownloadDocumentQuery, DownloadDocumentQueryVariables>;
export function useDownloadDocumentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadDocumentQuery, DownloadDocumentQueryVariables>): Apollo.UseSuspenseQueryResult<DownloadDocumentQuery | undefined, DownloadDocumentQueryVariables>;
export function useDownloadDocumentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadDocumentQuery, DownloadDocumentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadDocumentQuery, DownloadDocumentQueryVariables>(DownloadDocumentDocument, options);
        }
export type DownloadDocumentQueryHookResult = ReturnType<typeof useDownloadDocumentQuery>;
export type DownloadDocumentLazyQueryHookResult = ReturnType<typeof useDownloadDocumentLazyQuery>;
export type DownloadDocumentSuspenseQueryHookResult = ReturnType<typeof useDownloadDocumentSuspenseQuery>;
export type DownloadDocumentQueryResult = Apollo.QueryResult<DownloadDocumentQuery, DownloadDocumentQueryVariables>;
export const DownloadDocumentEcapTLogInfoDocument = gql`
    query downloadDocumentEcapTLogInfo($documentDownloadInputs: [DocumentDownloadInputs!]!) {
  downloadDocumentEcapTLogInfo(documentDownloadInputs: $documentDownloadInputs) {
    failureDocuments {
      id
      blobId
      messageId
      errorMessage
    }
    successDocuments {
      id
      messageId
      blobId
    }
    zipFileData
    encodedZipFileData
    errorMessage
  }
}
    `;

/**
 * __useDownloadDocumentEcapTLogInfoQuery__
 *
 * To run a query within a React component, call `useDownloadDocumentEcapTLogInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadDocumentEcapTLogInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadDocumentEcapTLogInfoQuery({
 *   variables: {
 *      documentDownloadInputs: // value for 'documentDownloadInputs'
 *   },
 * });
 */
export function useDownloadDocumentEcapTLogInfoQuery(baseOptions: Apollo.QueryHookOptions<DownloadDocumentEcapTLogInfoQuery, DownloadDocumentEcapTLogInfoQueryVariables> & ({ variables: DownloadDocumentEcapTLogInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadDocumentEcapTLogInfoQuery, DownloadDocumentEcapTLogInfoQueryVariables>(DownloadDocumentEcapTLogInfoDocument, options);
      }
export function useDownloadDocumentEcapTLogInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadDocumentEcapTLogInfoQuery, DownloadDocumentEcapTLogInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadDocumentEcapTLogInfoQuery, DownloadDocumentEcapTLogInfoQueryVariables>(DownloadDocumentEcapTLogInfoDocument, options);
        }
// @ts-ignore
export function useDownloadDocumentEcapTLogInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DownloadDocumentEcapTLogInfoQuery, DownloadDocumentEcapTLogInfoQueryVariables>): Apollo.UseSuspenseQueryResult<DownloadDocumentEcapTLogInfoQuery, DownloadDocumentEcapTLogInfoQueryVariables>;
export function useDownloadDocumentEcapTLogInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadDocumentEcapTLogInfoQuery, DownloadDocumentEcapTLogInfoQueryVariables>): Apollo.UseSuspenseQueryResult<DownloadDocumentEcapTLogInfoQuery | undefined, DownloadDocumentEcapTLogInfoQueryVariables>;
export function useDownloadDocumentEcapTLogInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadDocumentEcapTLogInfoQuery, DownloadDocumentEcapTLogInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadDocumentEcapTLogInfoQuery, DownloadDocumentEcapTLogInfoQueryVariables>(DownloadDocumentEcapTLogInfoDocument, options);
        }
export type DownloadDocumentEcapTLogInfoQueryHookResult = ReturnType<typeof useDownloadDocumentEcapTLogInfoQuery>;
export type DownloadDocumentEcapTLogInfoLazyQueryHookResult = ReturnType<typeof useDownloadDocumentEcapTLogInfoLazyQuery>;
export type DownloadDocumentEcapTLogInfoSuspenseQueryHookResult = ReturnType<typeof useDownloadDocumentEcapTLogInfoSuspenseQuery>;
export type DownloadDocumentEcapTLogInfoQueryResult = Apollo.QueryResult<DownloadDocumentEcapTLogInfoQuery, DownloadDocumentEcapTLogInfoQueryVariables>;
export const DownloadDocumentEcapDocument = gql`
    query downloadDocumentEcap($documentDownloadInputs: [DocumentDownloadInputs!]!) {
  downloadDocumentEcap(documentDownloadInputs: $documentDownloadInputs) {
    failureDocuments {
      id
      blobId
      messageId
      errorMessage
    }
    successDocuments {
      id
      messageId
      blobId
    }
    zipFileData
    encodedZipFileData
    errorMessage
  }
}
    `;

/**
 * __useDownloadDocumentEcapQuery__
 *
 * To run a query within a React component, call `useDownloadDocumentEcapQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadDocumentEcapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadDocumentEcapQuery({
 *   variables: {
 *      documentDownloadInputs: // value for 'documentDownloadInputs'
 *   },
 * });
 */
export function useDownloadDocumentEcapQuery(baseOptions: Apollo.QueryHookOptions<DownloadDocumentEcapQuery, DownloadDocumentEcapQueryVariables> & ({ variables: DownloadDocumentEcapQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadDocumentEcapQuery, DownloadDocumentEcapQueryVariables>(DownloadDocumentEcapDocument, options);
      }
export function useDownloadDocumentEcapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadDocumentEcapQuery, DownloadDocumentEcapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadDocumentEcapQuery, DownloadDocumentEcapQueryVariables>(DownloadDocumentEcapDocument, options);
        }
// @ts-ignore
export function useDownloadDocumentEcapSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DownloadDocumentEcapQuery, DownloadDocumentEcapQueryVariables>): Apollo.UseSuspenseQueryResult<DownloadDocumentEcapQuery, DownloadDocumentEcapQueryVariables>;
export function useDownloadDocumentEcapSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadDocumentEcapQuery, DownloadDocumentEcapQueryVariables>): Apollo.UseSuspenseQueryResult<DownloadDocumentEcapQuery | undefined, DownloadDocumentEcapQueryVariables>;
export function useDownloadDocumentEcapSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadDocumentEcapQuery, DownloadDocumentEcapQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadDocumentEcapQuery, DownloadDocumentEcapQueryVariables>(DownloadDocumentEcapDocument, options);
        }
export type DownloadDocumentEcapQueryHookResult = ReturnType<typeof useDownloadDocumentEcapQuery>;
export type DownloadDocumentEcapLazyQueryHookResult = ReturnType<typeof useDownloadDocumentEcapLazyQuery>;
export type DownloadDocumentEcapSuspenseQueryHookResult = ReturnType<typeof useDownloadDocumentEcapSuspenseQuery>;
export type DownloadDocumentEcapQueryResult = Apollo.QueryResult<DownloadDocumentEcapQuery, DownloadDocumentEcapQueryVariables>;
export const DownloadMultiDocumentDocument = gql`
    query downloadMultiDocument($documentDownloadInputs: [DocumentDownloadInput!]!) {
  downloadMultipleDocument(documentDownloadInputs: $documentDownloadInputs) {
    failureDocuments {
      documentId
      documentName
      documentLink
      documentPath
      errorMessage
    }
    successDocuments {
      documentId
      documentName
      documentLink
      documentPath
    }
    zipFileData
    encodedZipFileData
    errorMessage
  }
}
    `;

/**
 * __useDownloadMultiDocumentQuery__
 *
 * To run a query within a React component, call `useDownloadMultiDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadMultiDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadMultiDocumentQuery({
 *   variables: {
 *      documentDownloadInputs: // value for 'documentDownloadInputs'
 *   },
 * });
 */
export function useDownloadMultiDocumentQuery(baseOptions: Apollo.QueryHookOptions<DownloadMultiDocumentQuery, DownloadMultiDocumentQueryVariables> & ({ variables: DownloadMultiDocumentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadMultiDocumentQuery, DownloadMultiDocumentQueryVariables>(DownloadMultiDocumentDocument, options);
      }
export function useDownloadMultiDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadMultiDocumentQuery, DownloadMultiDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadMultiDocumentQuery, DownloadMultiDocumentQueryVariables>(DownloadMultiDocumentDocument, options);
        }
// @ts-ignore
export function useDownloadMultiDocumentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DownloadMultiDocumentQuery, DownloadMultiDocumentQueryVariables>): Apollo.UseSuspenseQueryResult<DownloadMultiDocumentQuery, DownloadMultiDocumentQueryVariables>;
export function useDownloadMultiDocumentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadMultiDocumentQuery, DownloadMultiDocumentQueryVariables>): Apollo.UseSuspenseQueryResult<DownloadMultiDocumentQuery | undefined, DownloadMultiDocumentQueryVariables>;
export function useDownloadMultiDocumentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadMultiDocumentQuery, DownloadMultiDocumentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadMultiDocumentQuery, DownloadMultiDocumentQueryVariables>(DownloadMultiDocumentDocument, options);
        }
export type DownloadMultiDocumentQueryHookResult = ReturnType<typeof useDownloadMultiDocumentQuery>;
export type DownloadMultiDocumentLazyQueryHookResult = ReturnType<typeof useDownloadMultiDocumentLazyQuery>;
export type DownloadMultiDocumentSuspenseQueryHookResult = ReturnType<typeof useDownloadMultiDocumentSuspenseQuery>;
export type DownloadMultiDocumentQueryResult = Apollo.QueryResult<DownloadMultiDocumentQuery, DownloadMultiDocumentQueryVariables>;
export const GetPartnerDocsListDocument = gql`
    query getPartnerDocsList($docListInput: DocListInput!) {
  getPartnerDocsList(docListInput: $docListInput) {
    id
    blobId
    messageId
    duplicate
    bmwCompany
    country
    currency
    documentDate
    documentNumber
    documentType
    phraseId
    downloaded
    format
    grossAmount
    partnerName
    partnerNumber
    processCode
    receptionDate
    sdiNumber
    status
    taxAmount
    vinNumber
    statusPhraseId
    fileName
    attachment
    shipPartnerNo
    externalDocumentNumber
  }
}
    `;

/**
 * __useGetPartnerDocsListQuery__
 *
 * To run a query within a React component, call `useGetPartnerDocsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerDocsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerDocsListQuery({
 *   variables: {
 *      docListInput: // value for 'docListInput'
 *   },
 * });
 */
export function useGetPartnerDocsListQuery(baseOptions: Apollo.QueryHookOptions<GetPartnerDocsListQuery, GetPartnerDocsListQueryVariables> & ({ variables: GetPartnerDocsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartnerDocsListQuery, GetPartnerDocsListQueryVariables>(GetPartnerDocsListDocument, options);
      }
export function useGetPartnerDocsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartnerDocsListQuery, GetPartnerDocsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartnerDocsListQuery, GetPartnerDocsListQueryVariables>(GetPartnerDocsListDocument, options);
        }
// @ts-ignore
export function useGetPartnerDocsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPartnerDocsListQuery, GetPartnerDocsListQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartnerDocsListQuery, GetPartnerDocsListQueryVariables>;
export function useGetPartnerDocsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartnerDocsListQuery, GetPartnerDocsListQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartnerDocsListQuery | undefined, GetPartnerDocsListQueryVariables>;
export function useGetPartnerDocsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartnerDocsListQuery, GetPartnerDocsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPartnerDocsListQuery, GetPartnerDocsListQueryVariables>(GetPartnerDocsListDocument, options);
        }
export type GetPartnerDocsListQueryHookResult = ReturnType<typeof useGetPartnerDocsListQuery>;
export type GetPartnerDocsListLazyQueryHookResult = ReturnType<typeof useGetPartnerDocsListLazyQuery>;
export type GetPartnerDocsListSuspenseQueryHookResult = ReturnType<typeof useGetPartnerDocsListSuspenseQuery>;
export type GetPartnerDocsListQueryResult = Apollo.QueryResult<GetPartnerDocsListQuery, GetPartnerDocsListQueryVariables>;
export const GetFsmPartnerDocsListDocument = gql`
    query getFsmPartnerDocsList($docListInput: DocListInput!) {
  getFsmPartnerDocsList(docListInput: $docListInput) {
    id
    blobId
    fileName
    messageId
    duplicate
    bmwCompany
    country
    currency
    documentDate
    documentNumber
    documentType
    phraseId
    downloaded
    format
    grossAmount
    partnerName
    partnerNumber
    processCode
    receptionDate
    sdiNumber
    status
    taxAmount
    vinNumber
    statusPhraseId
    errorMessage
    attachment
    shipPartnerNo
    externalDocumentNumber
    duplicate
  }
}
    `;

/**
 * __useGetFsmPartnerDocsListQuery__
 *
 * To run a query within a React component, call `useGetFsmPartnerDocsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFsmPartnerDocsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFsmPartnerDocsListQuery({
 *   variables: {
 *      docListInput: // value for 'docListInput'
 *   },
 * });
 */
export function useGetFsmPartnerDocsListQuery(baseOptions: Apollo.QueryHookOptions<GetFsmPartnerDocsListQuery, GetFsmPartnerDocsListQueryVariables> & ({ variables: GetFsmPartnerDocsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFsmPartnerDocsListQuery, GetFsmPartnerDocsListQueryVariables>(GetFsmPartnerDocsListDocument, options);
      }
export function useGetFsmPartnerDocsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFsmPartnerDocsListQuery, GetFsmPartnerDocsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFsmPartnerDocsListQuery, GetFsmPartnerDocsListQueryVariables>(GetFsmPartnerDocsListDocument, options);
        }
// @ts-ignore
export function useGetFsmPartnerDocsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFsmPartnerDocsListQuery, GetFsmPartnerDocsListQueryVariables>): Apollo.UseSuspenseQueryResult<GetFsmPartnerDocsListQuery, GetFsmPartnerDocsListQueryVariables>;
export function useGetFsmPartnerDocsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFsmPartnerDocsListQuery, GetFsmPartnerDocsListQueryVariables>): Apollo.UseSuspenseQueryResult<GetFsmPartnerDocsListQuery | undefined, GetFsmPartnerDocsListQueryVariables>;
export function useGetFsmPartnerDocsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFsmPartnerDocsListQuery, GetFsmPartnerDocsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFsmPartnerDocsListQuery, GetFsmPartnerDocsListQueryVariables>(GetFsmPartnerDocsListDocument, options);
        }
export type GetFsmPartnerDocsListQueryHookResult = ReturnType<typeof useGetFsmPartnerDocsListQuery>;
export type GetFsmPartnerDocsListLazyQueryHookResult = ReturnType<typeof useGetFsmPartnerDocsListLazyQuery>;
export type GetFsmPartnerDocsListSuspenseQueryHookResult = ReturnType<typeof useGetFsmPartnerDocsListSuspenseQuery>;
export type GetFsmPartnerDocsListQueryResult = Apollo.QueryResult<GetFsmPartnerDocsListQuery, GetFsmPartnerDocsListQueryVariables>;
export const GetMissingInvoicesDocsListDocument = gql`
    query getMissingInvoicesDocsList($docListInput: DocListInput!) {
  getMissingInvoicesDocsList(docListInput: $docListInput) {
    ecDocumentId
    messageId
    partnerNo
    companyPartnerId
    correctCompanyPartnerId
    documentNumber
    street1
    street2
    city
    countryCode
    postalCode
    region
    regionCode
    companyVatCountryCode
    companyVatCode
    companyVatCodeFromCompanyVatCode
    companyVatCountryCodeFromCompanyVatCode
    insertUser
    insertTime
    companyNameFromPartnerCompanySystem
    companyCode
    companyCodeFromPartnerCompanySystem
    category
    partnerAddressTypeFromPartnerAddress
    partnerCityFromPartnerAddress
    partnerCountryCodeFromPartnerAddress
    partnerName
    partnerNameFromPartnerCompanySystem
    partnerNoFromPartnerCompanySystem
    partnerPostalCodeFromPartnerAddress
    partnerRegionFromPartnerAddress
    partnerRegionCodeFromPartnerAddress
    partnerStreet1FromPartnerAddress
    partnerStreet2FromPartnerAddress
    partnerVatCode
    partnerVatCodeFromPartnerVatCode
    partnerVatCountryCodeFromPartnerVatCode
    partnerVatCountryCode
    processingStatusFlag
    updateTime
    partnerNoIssue
    partnerNameIssue
    companyCodeIssue
    partnerAddressIssue
    countryCodeAddressIssue
    partnerVatCodeIssue
    partnerVatCountryCodeIssue
    companyPartnerIdIssue
    companyVatCodeIssue
    attachmentPending
    logInfoId
    fileName
    blobId
    discrepancies
  }
}
    `;

/**
 * __useGetMissingInvoicesDocsListQuery__
 *
 * To run a query within a React component, call `useGetMissingInvoicesDocsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMissingInvoicesDocsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMissingInvoicesDocsListQuery({
 *   variables: {
 *      docListInput: // value for 'docListInput'
 *   },
 * });
 */
export function useGetMissingInvoicesDocsListQuery(baseOptions: Apollo.QueryHookOptions<GetMissingInvoicesDocsListQuery, GetMissingInvoicesDocsListQueryVariables> & ({ variables: GetMissingInvoicesDocsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMissingInvoicesDocsListQuery, GetMissingInvoicesDocsListQueryVariables>(GetMissingInvoicesDocsListDocument, options);
      }
export function useGetMissingInvoicesDocsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMissingInvoicesDocsListQuery, GetMissingInvoicesDocsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMissingInvoicesDocsListQuery, GetMissingInvoicesDocsListQueryVariables>(GetMissingInvoicesDocsListDocument, options);
        }
// @ts-ignore
export function useGetMissingInvoicesDocsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMissingInvoicesDocsListQuery, GetMissingInvoicesDocsListQueryVariables>): Apollo.UseSuspenseQueryResult<GetMissingInvoicesDocsListQuery, GetMissingInvoicesDocsListQueryVariables>;
export function useGetMissingInvoicesDocsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMissingInvoicesDocsListQuery, GetMissingInvoicesDocsListQueryVariables>): Apollo.UseSuspenseQueryResult<GetMissingInvoicesDocsListQuery | undefined, GetMissingInvoicesDocsListQueryVariables>;
export function useGetMissingInvoicesDocsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMissingInvoicesDocsListQuery, GetMissingInvoicesDocsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMissingInvoicesDocsListQuery, GetMissingInvoicesDocsListQueryVariables>(GetMissingInvoicesDocsListDocument, options);
        }
export type GetMissingInvoicesDocsListQueryHookResult = ReturnType<typeof useGetMissingInvoicesDocsListQuery>;
export type GetMissingInvoicesDocsListLazyQueryHookResult = ReturnType<typeof useGetMissingInvoicesDocsListLazyQuery>;
export type GetMissingInvoicesDocsListSuspenseQueryHookResult = ReturnType<typeof useGetMissingInvoicesDocsListSuspenseQuery>;
export type GetMissingInvoicesDocsListQueryResult = Apollo.QueryResult<GetMissingInvoicesDocsListQuery, GetMissingInvoicesDocsListQueryVariables>;
export const GetMissingInvoicesDocsListGroupedDocument = gql`
    query getMissingInvoicesDocsListGrouped($docListInput: DocListInput!) {
  getMissingInvoicesDocsListGrouped(docListInput: $docListInput) {
    rowNo
    processingStatusFlag
    updateTime
  }
}
    `;

/**
 * __useGetMissingInvoicesDocsListGroupedQuery__
 *
 * To run a query within a React component, call `useGetMissingInvoicesDocsListGroupedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMissingInvoicesDocsListGroupedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMissingInvoicesDocsListGroupedQuery({
 *   variables: {
 *      docListInput: // value for 'docListInput'
 *   },
 * });
 */
export function useGetMissingInvoicesDocsListGroupedQuery(baseOptions: Apollo.QueryHookOptions<GetMissingInvoicesDocsListGroupedQuery, GetMissingInvoicesDocsListGroupedQueryVariables> & ({ variables: GetMissingInvoicesDocsListGroupedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMissingInvoicesDocsListGroupedQuery, GetMissingInvoicesDocsListGroupedQueryVariables>(GetMissingInvoicesDocsListGroupedDocument, options);
      }
export function useGetMissingInvoicesDocsListGroupedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMissingInvoicesDocsListGroupedQuery, GetMissingInvoicesDocsListGroupedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMissingInvoicesDocsListGroupedQuery, GetMissingInvoicesDocsListGroupedQueryVariables>(GetMissingInvoicesDocsListGroupedDocument, options);
        }
// @ts-ignore
export function useGetMissingInvoicesDocsListGroupedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMissingInvoicesDocsListGroupedQuery, GetMissingInvoicesDocsListGroupedQueryVariables>): Apollo.UseSuspenseQueryResult<GetMissingInvoicesDocsListGroupedQuery, GetMissingInvoicesDocsListGroupedQueryVariables>;
export function useGetMissingInvoicesDocsListGroupedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMissingInvoicesDocsListGroupedQuery, GetMissingInvoicesDocsListGroupedQueryVariables>): Apollo.UseSuspenseQueryResult<GetMissingInvoicesDocsListGroupedQuery | undefined, GetMissingInvoicesDocsListGroupedQueryVariables>;
export function useGetMissingInvoicesDocsListGroupedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMissingInvoicesDocsListGroupedQuery, GetMissingInvoicesDocsListGroupedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMissingInvoicesDocsListGroupedQuery, GetMissingInvoicesDocsListGroupedQueryVariables>(GetMissingInvoicesDocsListGroupedDocument, options);
        }
export type GetMissingInvoicesDocsListGroupedQueryHookResult = ReturnType<typeof useGetMissingInvoicesDocsListGroupedQuery>;
export type GetMissingInvoicesDocsListGroupedLazyQueryHookResult = ReturnType<typeof useGetMissingInvoicesDocsListGroupedLazyQuery>;
export type GetMissingInvoicesDocsListGroupedSuspenseQueryHookResult = ReturnType<typeof useGetMissingInvoicesDocsListGroupedSuspenseQuery>;
export type GetMissingInvoicesDocsListGroupedQueryResult = Apollo.QueryResult<GetMissingInvoicesDocsListGroupedQuery, GetMissingInvoicesDocsListGroupedQueryVariables>;